import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Card, CardHeader, ListItemIcon, Stack } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import request, { gql } from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import {
  AllOpportunityByMasterQuery,
  AllOpportunityByUserQuery,
  AllOpportunityQuery,
} from "../../lib/graphQL/graphQuery";
import { DeleteOpportunityMutation } from "../../lib/graphQL/graphMutation";
import { useLoading } from "../../context/LodingContext";
import PageLoading from "../../components/Loading/PageLoading";
import TableComponent from "../../components/GridTable/TableComponent";

export default function OpportunityListTable() {
  const { currentUser } = useAuth();
  const isUser = currentUser?.role;
  const navigate = useNavigate();
  const [opportunityData, setOpportunityData] = useState([]);
  const [id, setId] = useState("");
  const [status, setStatus] = useState(false);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [isLoading, setIsLoading] = useState(false);
  const { circleLoading, setCirleLoading } = useLoading();

  const opportunityListTable = {
    columns: [
      {
        label: "S.No",
        field: "sno",
        // flex: 1,
        width: 100,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Opportunity ID",
        field: "oppid",
        name: "Opportunity ID",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Opportunity Type",
        field: "opportunityType",
        name: "Opportunity Type",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Opportunity From",
        field: "opportunityFrom",
        name: "Opportunity From",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Contact",
        field: "contact",
        name: "Contact",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Stage",
        field: "stage",
        name: "stage",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Created By",
        field: "user",
        name: "Created By",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Created At",
        field: "createdAt",
        name: "Created At",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
    ],
    rows: opportunityData.reverse().map(
      (item, index) => (
      
        {
          sno: index + 1,
          id: item.id,
          oppid: item.oppid,
          opportunityType: item.opportunityType?.typeName,
          contact: item.contact?.firstName,
          opportunityFrom: item.opportunityFrom,
          status: item.status,
          // stage: item?.stage,
          stage: (
            <>
              <div style={{ marginTop: "10px" }}>
                {item?.stage}
                <div className="bar-mainbox">
                  {item?.stage?.toLowerCase() == "qualification" && (
                    <div style={{ width: "15%" }}></div>
                  )}
                  {item?.stage?.toLowerCase() == "need analysis" && (
                    <div style={{ width: "30%" }}></div>
                  )}
                  {item?.stage?.toLowerCase() == "presentation" && (
                    <div style={{ width: "40%" }}></div>
                  )}
                  {item?.stage?.toLowerCase() == "proposal development" && (
                    <div style={{ width: "40%" }}></div>
                  )}
                  {item?.stage?.toLowerCase() == "proposal" && (
                    <div style={{ width: "50%" }}></div>
                  )}
                  {item?.stage?.toLowerCase() == "negotiation" && (
                    <div style={{ width: "60%" }}></div>
                  )}
                  {item?.stage?.toLowerCase() == "contracting" && (
                    <div style={{ width: "80%" }}></div>
                  )}
                  {item?.stage?.toLowerCase() == "closed won" && (
                    <div style={{ width: "100%" }}></div>
                  )}
                  {item?.stage?.toLowerCase() == "closed lost" && (
                    <div style={{ width: "100%", background: "red" }}></div>
                  )}
                </div>
              </div>
            </>
          ),
          user: item.user.username,
          createdAt: item.createdAt ? item.createdAt.slice(0, 10) : "N/A",
        }
      )
    ),
  };

  const fetchOpportunityData = () => {
    setIsLoading(true);
    request(
      BASEURL,
      isUser.toLowerCase() == "manager"
        ? AllOpportunityByMasterQuery
        : isUser.toLowerCase() == "employee"
        ? AllOpportunityByUserQuery
        : isUser.toLowerCase() == "superuser"
        ? AllOpportunityQuery
        : "",
      { id: currentUser?.id }
    )
      .then((res) => {
        setOpportunityData(
          isUser.toLowerCase() == "manager"
            ? res.getOpportunityByMaster
            : isUser.toLowerCase() == "employee"
            ? res.getOpportunityByUser
            : isUser.toLowerCase() == "superuser"
            ? res.allOpportunity
            : []
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchOpportunityData();
    setStatus(false);
  }, [id, status]);

  const handleDeleteOpportunity = (row) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this row?"
    );
    if (confirmed) {
      request(BASEURL, DeleteOpportunityMutation, { id: row.id }).then(
        (res) => {
          setStatus(true);
        }
      );
    }
  };

  const handleNewOpportunity = () => {
    navigate("/opportunity/add-opportunity");
  };

  const onOpportunityListClick = (e) => {
    if (e?.id) {
      navigate(`/opportunity/add-opportunity?${e?.id}`);
    }
  };

  const onCheck=(list)=>
    {
      console.log("id-c",list)
    }
    
  const onDeleteALL=()=>
    {
      console.log("id-DELE")
    }

  return (
    <DashboardLayout>
      <TableComponent
      tableLoading={isLoading ? true : false }
      columns={opportunityListTable.columns}
      rowsData={opportunityListTable.rows}
      styles={{ paper: { padding: '16px' } }}
      head="Opportunity List"
      actions={true}
      checked={false}
      view={true}
      showAdd = {true}
      onCheck={onCheck}
      onEdit={onOpportunityListClick}
      onDelete={handleDeleteOpportunity}
      onView={onOpportunityListClick}
      onDeleteALL={onDeleteALL}
      addList={() => handleNewOpportunity()}
      />
      {/* <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Opportunity List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewOpportunity()}
              >
                Opportunity
              </MaterialButton>
            </Stack>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            // customHeight={550}
            rows={opportunityListTable.rows}
            columns={opportunityListTable.columns}
            // checkboxSelection={false}
            isSelectable={false}
            onRowClick={onOpportunityListClick}
            loading={pageState.loading}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No Opportunity found
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    You have not yet add any Opportunity details. Click on the
                    "Add Opportunity" button to start adding Opportunity
                    details.
                  </MaterialTypography>
                </Stack>
              ),
            }}
          />
        )}
        {isLoading && <PageLoading />}
      </Card> */}
    </DashboardLayout>
  );
}
